<template>
  <section class="hospital-showcase">
    <div class="section-inner">
      <!-- ---------- Heading ---------- -->
      <div class="si-head">
        <div class="sh-inner">
            <div class="sh-inner-part">
                <h2>RSKJP Melinda Cardio Vascular Center</h2>
            </div>
            <div class="sh-inner-part">
                <h1>Melinda Hospital Group</h1>
            </div>
            <div class="sh-inner-part">
                <p>Melinda Hospital Group terdiri dari beberapa rumah sakit yang berkualitas tinggi dan merupakan keluarga Melinda Hospital. Terdiri dari RSIA Melinda, RS Melinda 2, dan RSKJP Melinda Cardio Vascular. Ketiga rumah sakit penuh dengan dokter dan tenaga medis berpengalaman yang selalu siap memberikan perawatan kesehatan terbaik untuk Anda. Jika ingin mengetahui lebih banyak informasi dan layanan terbaru, akses link tautan di bawah ini.</p>
            </div>
        </div>
      </div>

      <!-- ---------- Body ---------- -->
      <div class="si-body">
        <div
          class="sb-part"
          v-for="(hosp, idx) in hospitals"
          :key="hosp.name"
          :class="{ 'is-right': idx % 2 }"
        >
          <!-- image background -->
          <picture class="sb-part-image">
            <img :src="hosp.image" :alt="hosp.alt" loading="lazy" />
          </picture>

          <!-- gradient overlay for better text readability -->
          <div class="sb-gradient" />

          <!-- text block -->
          <div class="sb-part-detail" :class="idx % 2 ? 'spd-right' : 'spd-left'">
            <div class="spd-label"><span>{{ hosp.group }}</span></div>
            <div class="spd-title"><h2>{{ hosp.name }}</h2></div>
            <div class="spd-description" v-html="hosp.description" />
            <div class="spd-link">
              <a :href="hosp.link" target="_blank" rel="noopener noreferrer">
                <span>Link to Website</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const hospitals = [
  {
    group: 'Melinda Hospital Group',
    name: 'Melinda Hospital',
    image: new URL('../../assets/images/pictures/rsiam.webp', import.meta.url).href,
    alt: 'RSIA Melinda',
    description:
      'RSIA Melinda merupakan Rumah Sakit Ibu dan Anak. "Kesehatan adalah kunci utama kecantikan dan kebahagiaan seorang wanita. Dengan tulus kami berkomitmen mewujudkan impian setiap wanita untuk tampil cantik, sehat dan bahagia."',
    link: 'https://rsiamelinda.com/'
  },
  {
    group: 'Melinda Hospital Group',
    name: 'RS Melinda 2',
    image: new URL('../../assets/images/pictures/rsm2.webp', import.meta.url).href,
    alt: 'RS Melinda 2',
    description:
      'RS Melinda 2 merupakan jawaban atas keinginan masyarakat yang membutuhkan dan mengidamkan pelayanan kesehatan yang lebih nyaman dengan profesionalisme yang tinggi. Kami melayani dengan sepenuh hati dan disertai dengan pikiran, perasaan, dan kehendak yang tulus.',
    link: 'https://rsmelinda2.com/'
  }
]
</script>

<style scoped>
/******************* Layout *******************/
section {
  padding: 0;
}
.section-inner {
  display: flex;
  flex-direction: column;
}
.si-head {
  padding: 2.5rem 2.5%;
  background: var(--cream-bg);
  color: var(--navy);
}
.sh-inner{
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: center;
    justify-content: center;
    transition: 0.2s;
}
.sh-inner-part{
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0.5rem 0 0.5rem 0;
    transition: 0.2s;
}
.sh-inner-part h2{
    margin: 0;
    font-size: 1.125rem;
    color: var(--primary);
}
.sh-inner-part h1{
    font-family: poppins;
    font-size: 3.25rem;
    margin: 0;
    transition: 0.2s;
}
.sh-inner-part p{
    margin: 0;
}

/******************* Showcase Card *******************/
.si-body {
  display: flex;
  flex-wrap: wrap;
}
.sb-part {
  position: relative;
  width: 100%;
  min-height: 360px;
  overflow: hidden;
  display: flex;
}
@media (min-width: 992px) {
  .sb-part {
    width: 50%; /* dua kolom kiri‑kanan di desktop */
  }
}
/* gambar full‑bleed */
.sb-part-image,
.sb-part-image img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
/* gradient (atas gelap bawah terang) */
.sb-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0, 21, 51, 0.65) 0%, rgba(0, 0, 0, 0.15) 50%, rgba(0, 0, 0, 0) 100%);
  pointer-events: none;
}

/******************* Text Overlay *******************/
.sb-part-detail {
  position: relative;
  z-index: 2;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  /* default left variant (spd-left) */
  padding: 5rem 1rem 1rem 10%;
}
.spd-left {
  align-items: flex-start;
}
.spd-right {
  margin-left: auto;
  align-items: flex-end;
  padding: 5rem 10% 1rem 1rem;
  text-align: right;
}

/******************* Typography *******************/
.spd-label {
  color: var(--primary);
  font-size: 1.125rem;
  font-weight: 600;
  text-shadow: 1px 1px 4px rgb(0 0 0 / 80%);
}
.spd-title h2 {
  font-family: poppins;
  font-size: 2.625rem;
  font-weight: 700;
  margin: 0;
  color: var(--cream-bg);
  text-shadow: 1px 1px 4px rgb(0 0 0 / 80%);
}
.spd-description {
  color: var(--white);
  text-shadow: 1px 1px 4px rgb(0 0 0 / 90%);
}
.spd-description p {
  margin: 0;
  text-align: justify;
}
.spd-link {
  padding-top: 1rem;
}
.spd-link a {
  text-decoration: none;
  color: var(--navy);
  background: var(--cream-bg);
  padding: 0.5rem 2rem;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 600;
  display: inline-block;
  transition: background 0.25s;
}
.spd-link a:hover {
  text-decoration: underline;
  background: var(--primary);
  color: var(--white);
}

/******************* Responsive Tweaks *******************/
@media (min-width: 1200px) {
  .sb-part {
    min-height: 480px;
  }
}
@media (max-width: 992px) {
  .sb-part-detail {
    max-width: unset;
    padding: 4rem 5% 1.5rem;
    text-align: left;
  }
  .spd-right {
    margin-left: 0;
    align-items: flex-start;
    text-align: left;
  }
  .sb-gradient {
    background: linear-gradient(180deg, rgba(0, 21, 51, 0.7) 0%, rgba(0, 0, 0, 0.05) 60%, rgba(0,0,0,0) 100%);
  }
}
@media only screen and (max-width: 750px){
    .sh-inner-part h1{
        font-size: 1.5rem;
    }
}
@media (max-width: 576px) {
  .sb-part-detail {
    padding: 3rem 1.25rem 1rem;
  }
  .spd-title h2 {
    font-size: 1.2rem;
  }
}
</style>
